export default function SearchAthletes(sport, keyword) {
  const currentURL = window.location.href;
  const ext = currentURL.includes("test") ? "test" : "com";
  const shrk = $('#shrk').val();
  let lcKeyword = keyword.toLowerCase();
  let url = "https://wagedwar." + ext + '/wp-json/athletes/v1/search/' + sport + '/' + encodeURIComponent(lcKeyword) + '/' + shrk;

  try {
    return fetch(url)
      .then((result) => result.json())
      .then((athletes) => {
        return athletes;
      });
  } catch (error) {
    console.log(error);
  }
}
